import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { itIT } from "@mui/material/locale";
import "../fontStyle.css"; // Import dei font Google

export const developmentTheme = responsiveFontSizes(
    createTheme(
        {
            // CONFIGURAZIONE FONT
            typography: {
                // Font generale per body, body2, Typography variant="body1/body2"
                fontFamily: [
                    "Roboto", // Font principale per il body
                    "Lato", // Fallback moderno
                    "-apple-system",
                    "BlinkMacSystemFont",
                    '"Segoe UI"',
                    "Arial",
                    "sans-serif",
                ].join(","),

                // Font specifici per elementi particolari
                h1: { fontFamily: "Merriweather", fontWeight: 700 }, // Serif per eleganza
                h2: { fontFamily: "Merriweather", fontWeight: 600 },
                h3: { fontFamily: "Lato", fontWeight: 600 }, // Sans-serif moderno
                h4: { fontFamily: "Lato", fontWeight: 500 },
                h5: { fontFamily: "Roboto", fontWeight: 500 }, // Come il body
                h6: { fontFamily: "Roboto", fontWeight: 500 },
                button: { fontFamily: "Lato", fontWeight: 500 },
            },

            // CONFIGURAZIONE PALETTE
            palette: {
                mode: "light",
                primary: {
                    main: "#1976d2",
                    dark: "#0d47a1",
                    light: "#42a5f5",
                },
                secondary: {
                    main: "#dc004e",
                },
                text: {
                    primary: "#212121",
                    secondary: "#757575",
                },
                error: {
                    main: "#f44336",
                },
                info: {
                    main: "#2196f3",
                },
                success: {
                    main: "#4caf50",
                },
                divider: "rgba(0,0,0,0.12)",
                background: {
                    default: "#f5f5f5",
                    paper: "#ffffff",
                },
            },

            // CONFIGURAZIONE FORME
            shape: {
                borderRadius: 4,
            },

            // CONFIGURAZIONE COMPONENTI
            components: {
                // BUTTON
                MuiButton: {
                    styleOverrides: {
                        root: {
                            borderRadius: 4,
                            fontWeight: 500,
                            textTransform: "capitalize",
                            padding: "6px 16px",
                        },
                        contained: {
                            boxShadow: "0 2px 4px rgba(25, 118, 210, 0.2)",
                            "&:hover": {
                                boxShadow: "0 4px 8px rgba(25, 118, 210, 0.3)",
                            },
                        },
                        outlined: {
                            borderWidth: "1px",
                            "&:hover": {
                                borderWidth: "1px",
                            },
                        },
                    },
                },
                // CARD
                MuiCard: {
                    styleOverrides: {
                        root: {
                            borderRadius: 4,
                        },
                    },
                },
                // TEXTFIELD
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 4,
                            },
                        },
                    },
                },
            },

            // COLORI CUSTOM
            andonStatoPagamento: {
                inLavorazione: "#ffb74d",
                daRichiedere: "#64b5f6",
                inAttesaPagamento: "#fff176",
                parzialmentePagato: "#a5d6a7",
                pagato: "#81c784",
                annullato: "#bdbdbd",
            },
            coloriFiltro: {
                attivo: "#81c784",
                disattivo: "#e0e0e0",
            },
        },
        itIT
    )
);